import React, { Component } from 'react'
import Slider from 'react-slick'
import Fade from 'react-reveal/Fade'
import './index.css'

const quotes = [
  '“As a former Assistant District Attorney in the Bronx, I worked on numerous cases where Phil was opposing counsel. Phil has always been personable and professional. Most importantly, he is an excellent trial lawyer and negotiator. Whenever someone asks me to recommend a criminal defense attorney, Phil is always number one on my list.“',
  '“I worked with Phil for many years and had the pleasure of co-counseling a case with him. I saw first hand his devotion to his clients and his talent as a litigator. He is smart and savvy in the courtroom and masterful in front of a jury. He is a fierce and passionate advocate for his clients and highly respected by his adversaries and the judiciary. He is hardworking, trustworthy, and reliable. I would recommend him in a heartbeat.“',
  '“Phillip Hamilton saved my life. He represented me in a highly publicized national case. I was vilified by the media. I was charged with multiple felonies and misdemeanors. Through his due diligence ALL of these were dropped. I was able to walk away with NO criminal disposition. Thanks to Phil, I can hold my head high and continue with my life in freedom.“',
  '“Mr. Hamilton helped me fight a possession case almost 3 years ago. It was my first time arrested and, as expected, I was very nervous about the entire situation. I reached out to a few other attorneys as well, but quickly realized Mr. Hamilton was the choice for me. Ultimately, I got off w/ everything being dropped after staying clear of the law for 6 months. I always recommend him to anybody who asks about a lawyer, and would obviously use him anytime I needed representation.“',
  '“For obvious reasons, I never want to see Phil in a criminal courtroom again, however, if I knew of anyone who ever needed a good, trustworthy criminal defense attorney to get them out of a scary situation, I would recommend Phil in a heartbeat. He\'s simply that good.“'
]

const SLIDER_REF = 'slider-ref'

class Testimonials extends Component {
  constructor () {
    super()
    this.state = { currentSlide: 0 }
    this.setSlide = this.setSlide.bind(this)
    this.goToSlide = this.goToSlide.bind(this)
    this.prevSlide = this.prevSlide.bind(this)
    this.nextSlide = this.nextSlide.bind(this)
  }

  goToSlide (n) {
    return e => {
      this.refs[SLIDER_REF].slickGoTo(n)
    }
  }

  setSlide (n) {
    this.setState({ currentSlide: n })
  }

  prevSlide () {
    this.refs[SLIDER_REF].slickPrev()
  }

  nextSlide () {
    this.refs[SLIDER_REF].slickNext()
  }

  render () {
    const { currentSlide } = this.state

    return (
      <Fade>
        <div className="testimonials relative pa3 m0-auto pa4-ns">
          <h2 className="serif fw4 f3 black tc mb5 f1-ns">Testimonials</h2>
          <div className="tc">
            <div className="relative">
              <Slider {...{
                infinite: true,
                speed: 300,
                afterChange: this.setSlide,
                arrows: false,
                autoplay: true,
                autoplaySpeed: 5000
              }} ref={SLIDER_REF}>
                {quotes.map((q, i) => (
                  <div className="fw3 f5 f2-ns" key={i}>{q}</div>
                ))}
              </Slider>

              <div className="testimonials__arrows flex-row justify-between items-center absolute top-0 bottom-0 fw2 pointer red">
                <div onClick={this.prevSlide}>〈</div>
                <div onClick={this.nextSlide}>〉</div>
              </div>
            </div>
            <div className="testimonials__divider bg-red m0-auto mt4 mb6 mt6-ns mb7-ns" />
            <div className="flex flex-row justify-center pa0 relative ma0">
              {quotes.map((q, n) => (
                <div
                  key={n}
                  className={`testimonials__dot br-100 mh1 mh2-ns ${currentSlide === n ? 'bg-red' : 'bg-grey'}`}
                  onClick={this.goToSlide(n)}
                />
              ))}
            </div>
          </div>
        </div>
      </Fade>
    )
  }
}

export default Testimonials



// WEBPACK FOOTER //
// ./src/components/testimonials/index.js